import React from "react";
import { Box, Paper, List, ListItemIcon } from "@mui/material";
import WarningAmber from "@mui/icons-material/WarningAmber";
import DoNotDisturbAlt from "@mui/icons-material/DoNotDisturbAlt";
import { Message, MessageSections } from "../../../components/message/message";
import { Title } from "../Title/Title";
import BarekamText from "../../../components/text";
import {
  BarekamTextProhibited,
  BarekamTextRestricted,
  GridItem,
  ListItemDescription,
  ListItemTextWrapper,
  ListItemWrapper,
  TextWrapper,
} from "./styled.components";

import { prohibitedItems, restrictedItems } from "./data";
import Container from "../Container";
import { useAppSelector } from "../../../../redux/store";

const ProhibitedRestrictedProducts: React.FC = () => {

  const { languageId } = useAppSelector((state) => state.messagesReducer);

  return (
    <Box
      sx={{
        backgroundColor: "#F7F8FA",
        paddingTop: "60px",
        width: "100%",
      }}
      id="prohibited"
    >
      <Title variant="h2">
        <Message
          messageKey={"prohibited_restricted_products_title"}
          sectionId={MessageSections.MAIN}
        />
      </Title>
      <BarekamText variant={"s"} fontWeight={400} align={"center"}>
        <Message
          messageKey={"prohibited_restricted_products_description"}
          sectionId={MessageSections.MAIN}
        />
      </BarekamText>

      {/* Content */}
      <Container flexDirection="row" align="baseline">
        <GridItem item xs={12} md={6}>
          <Paper
            elevation={3}
            sx={{
              padding: "1rem 1rem 0 1rem",
            }}
          >
            <BarekamTextProhibited variant={"l"} align={"left"}>
              <DoNotDisturbAlt fontSize="small" sx={{ color: "#FFFFFF" }} />
              <Message
                messageKey={"prohibited_products"}
                sectionId={MessageSections.MAIN}
              />
            </BarekamTextProhibited>
            <List>
              {prohibitedItems[languageId - 1].map((item, index) => (
                <ListItemWrapper key={index}>
                  <ListItemIcon sx={{ minWidth: "28px" }}>
                    <DoNotDisturbAlt
                      fontSize="small"
                      sx={{ color: "#E53E3E" }}
                    />
                  </ListItemIcon>
                  <ListItemTextWrapper primary={item} />
                </ListItemWrapper>
              ))}
            </List>
          </Paper>
        </GridItem>
        <GridItem item xs={12} md={6}>
          <Paper
            elevation={3}
            sx={{
              padding: "1rem 1rem 0 1rem",
            }}
          >
            <BarekamTextRestricted variant={"l"} align={"left"}>
              <WarningAmber fontSize="small" sx={{ color: "#FFFFFF" }} />
              <Message
                messageKey={"restricted_products"}
                sectionId={MessageSections.MAIN}
              />
            </BarekamTextRestricted>
            <List>
              {restrictedItems[languageId - 1].map((item, index) => (
                <ListItemWrapper key={index}>
                  <ListItemIcon sx={{ minWidth: "28px" }}>
                    <WarningAmber fontSize="small" sx={{ color: "#DD6B20" }} />
                  </ListItemIcon>
                  <TextWrapper>
                    <ListItemTextWrapper primary={item.title} />
                    {item?.description && (
                      <ListItemDescription>
                        {item.description}
                      </ListItemDescription>
                    )}
                  </TextWrapper>
                </ListItemWrapper>
              ))}
            </List>
          </Paper>
        </GridItem>
      </Container>
    </Box>
  );
};

export default ProhibitedRestrictedProducts;
